import {redirect} from 'react-router-dom';

import {getGroups} from '@/services/authService';
import {
  forcedWorkTimeTrackingGroups,
  isEmployeeWorkTimeTrackingForced as isEmployeeForced,
  workTimeTrackingGroups,
} from '@/shared/work-time/utils/workTimeGroups';
import isCurrentClientEntitle from '@/utils/isCurrentClientEntitled';
import isCurrentWorkTimeSessionActive from '@/utils/isCurrentWorkTimeSessionActive';
import isEmployeeWorkTimeTrackingForced from '@/utils/isEmployeeWorkTimeTrackingForced';
import isGroupAuthorized from '@/utils/isGroupAuthorized';
import {
  authenticatedRootLoader,
  isLoaderRedirect,
} from '@/utils/protectedLoader';

export const workTimeHistoryLoader = async () => {
  const isWorkTimeEntitled = await isCurrentClientEntitle('WORK_TIME');

  if (!isWorkTimeEntitled) {
    return redirect('/not-entitled');
  }

  const groups = await getGroups();

  if (!isGroupAuthorized(groups, workTimeTrackingGroups)) {
    return redirect('/unauthorized');
  }

  return null;
};

export const startWorkLoader = async () => {
  const authResult = await authenticatedRootLoader();

  if (isLoaderRedirect(authResult)) return authResult;

  const {groups} = authResult;
  const isWorkTimeEntitled = await isCurrentClientEntitle('WORK_TIME');

  if (!isWorkTimeEntitled) {
    return redirect('/');
  }

  const isEmployee = isGroupAuthorized(groups, forcedWorkTimeTrackingGroups);
  if (!isEmployee) return redirect('/');

  const forceTrackingEnabled = await isEmployeeWorkTimeTrackingForced();
  const isWorkTimeForced = isEmployeeForced(groups, forceTrackingEnabled);
  const hasActiveWorkSession =
    isWorkTimeForced && (await isCurrentWorkTimeSessionActive());

  if (!isWorkTimeForced || hasActiveWorkSession) {
    return redirect('/');
  }

  return null;
};
